import { componentName, ScopesListClass } from './ScopesListClass';
import '@descope-ui/descope-list';
import '../boolean-fields/descope-checkbox';
import '../boolean-fields/descope-switch-toggle';

customElements.define(componentName, ScopesListClass);

export { ScopesListClass, componentName };
